import {createAction} from 'redux-actions'

export const sendPlinkLog = createAction('PANELS/PLINK/SEND_PLINK_LOG')
export const enablePlinkSSH = createAction('PANELS/PLINK/ENABLE_PLINK_SSH')
export const disablePlinkSSH = createAction('PANELS/PLINK/DISABLE_PLINK_SSH')
export const setPlinkError = createAction('PANELS/PLINK/SET_ERROR')